<template>
  <div id="app">
    <!-- Navbar -->
    <nav class="navbar">
      <div class="logo">
        <img src="/rueda_2025.png" alt="Logo principal" class="logo-img" />
        <!--<img src="/EXPOTECO.png" alt="Icono 1" class="extra-img" />-->
        <img src="/campo_ferial_2025.png" alt="Icono 2" class="extra-img" />
      </div>

      <ul class="nav-links" :class="{ active: menuOpen }">
        <li
          v-if="rol === 'admin'"
          @mouseover="showText = 'Empresas'"
          @mouseleave="showText = ''"
        >
          <router-link to="/empresas" aria-label="Empresas">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="white"
              class="size-6"
              width="24"
              height="24"
            >
              <path
                fill-rule="evenodd"
                d="M4.5 2.25a.75.75 0 0 0 0 1.5v16.5h-.75a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5h-.75V3.75a.75.75 0 0 0 0-1.5h-15ZM9 6a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5H9Zm-.75 3.75A.75.75 0 0 1 9 9h1.5a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75ZM9 12a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5H9Zm3.75-5.25A.75.75 0 0 1 13.5 6H15a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75ZM13.5 9a.75.75 0 0 0 0 1.5H15A.75.75 0 0 0 15 9h-1.5Zm-.75 3.75a.75.75 0 0 1 .75-.75H15a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75ZM9 19.5v-2.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-.75.75h-4.5A.75.75 0 0 1 9 19.5Z"
                clip-rule="evenodd"
              />
            </svg>
            <span v-if="showText === 'Empresas'">Empresas</span>
          </router-link>
        </li>

        <li
          v-if="rol === 'admin'"
          @mouseover="showText = 'Usuarios'"
          @mouseleave="showText = ''"
        >
          <router-link to="/usuarios" aria-label="Usuarios">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="white"
              viewBox="0 0 24 24"
              stroke="none"
              width="24"
              height="24"
            >
              <path
                d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"
              />
            </svg>
            <span v-if="showText === 'Usuarios'">Usuarios</span>
          </router-link>
        </li>

        <li
          v-if="rol === 'admin'"
          @mouseover="showText = 'Horarios'"
          @mouseleave="showText = ''"
        >
          <router-link to="/horarios" aria-label="Horarios">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="white"
              class="size-6"
              width="24"
              height="24"
            >
              <path
                fill-rule="evenodd"
                d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 0 0 0-1.5h-3.75V6Z"
                clip-rule="evenodd"
              />
            </svg>
            <span v-if="showText === 'Horarios'">Horarios</span>
          </router-link>
        </li>

        <li
          v-if="rol === 'admin'"
          @mouseover="showText = 'Mesas'"
          @mouseleave="showText = ''"
        >
          <router-link to="/mesas" aria-label="Mesas">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="white"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="white"
              class="size-6"
              width="24"
              height="24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-9A2.25 2.25 0 0 0 2.25 7.5v9a2.25 2.25 0 0 0 2.25 2.25Z"
              />
            </svg>
            <span v-if="showText === 'Mesas'">Mesas</span>
          </router-link>
        </li>

        <li
          v-if="rol === 'admin'"
          @mouseover="showText = 'Rubros'"
          @mouseleave="showText = ''"
        >
          <router-link to="/rubros" aria-label="Rubros">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="white"
              class="size-6"
              width="24"
              height="24"
            >
              <path
                fill-rule="evenodd"
                d="M7.5 5.25a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v.205c.933.085 1.857.197 2.774.334 1.454.218 2.476 1.483 2.476 2.917v3.033c0 1.211-.734 2.352-1.936 2.752A24.726 24.726 0 0 1 12 15.75c-2.73 0-5.357-.442-7.814-1.259-1.202-.4-1.936-1.541-1.936-2.752V8.706c0-1.434 1.022-2.7 2.476-2.917A48.814 48.814 0 0 1 7.5 5.455V5.25Zm7.5 0v.09a49.488 49.488 0 0 0-6 0v-.09a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5Zm-3 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
                clip-rule="evenodd"
              />
              <path
                d="M3 18.4v-2.796a4.3 4.3 0 0 0 .713.31A26.226 26.226 0 0 0 12 17.25c2.892 0 5.68-.468 8.287-1.335.252-.084.49-.189.713-.311V18.4c0 1.452-1.047 2.728-2.523 2.923-2.12.282-4.282.427-6.477.427a49.19 49.19 0 0 1-6.477-.427C4.047 21.128 3 19.852 3 18.4Z"
              />
            </svg>

            <span v-if="showText === 'Rubros'">Rubros</span>
          </router-link>
        </li>

        <li
          v-if="rol === 'user'"
          @mouseover="showText = 'PerfilEmpresa'"
          @mouseleave="showText = ''"
        >
          <router-link to="/perfilempresa" aria-label="PerfilEmpresa">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="white"
              class="size-6"
              width="24"
              height="24"
            >
              <path
                fill-rule="evenodd"
                d="M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5H5.625ZM7.5 15a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 7.5 15Zm.75 2.25a.75.75 0 0 0 0 1.5H12a.75.75 0 0 0 0-1.5H8.25Z"
                clip-rule="evenodd"
              />
              <path
                d="M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z"
              />
            </svg>

            <span v-if="showText === 'PerfilEmpresa'">Perfil Empresa</span>
          </router-link>
        </li>

        <li
          v-if="rol === 'user'"
          @mouseover="showText = 'OfertasDemanda'"
          @mouseleave="showText = ''"
        >
          <router-link to="/ofertasdemanda" aria-label="OfertasDemanda">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="white"
              width="24"
              height="24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 4v6h6M20 20v-6h-6M4 20l16-16"
              />
            </svg>
            <span v-if="showText === 'OfertasDemanda'">Oferta Demanda</span>
          </router-link>
        </li>

        <li
          v-if="rol === 'user'"
          @mouseover="showText = 'UParticipantesView'"
          @mouseleave="showText = ''"
        >
          <router-link to="/participantes" aria-label="UParticipantesView">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="white"
              class="size-6"
              width="24"
              height="24"
            >
              <path
                fill-rule="evenodd"
                d="M8.25 6.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM15.75 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM2.25 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM6.31 15.117A6.745 6.745 0 0 1 12 12a6.745 6.745 0 0 1 6.709 7.498.75.75 0 0 1-.372.568A12.696 12.696 0 0 1 12 21.75c-2.305 0-4.47-.612-6.337-1.684a.75.75 0 0 1-.372-.568 6.787 6.787 0 0 1 1.019-4.38Z"
                clip-rule="evenodd"
              />
              <path
                d="M5.082 14.254a8.287 8.287 0 0 0-1.308 5.135 9.687 9.687 0 0 1-1.764-.44l-.115-.04a.563.563 0 0 1-.373-.487l-.01-.121a3.75 3.75 0 0 1 3.57-4.047ZM20.226 19.389a8.287 8.287 0 0 0-1.308-5.135 3.75 3.75 0 0 1 3.57 4.047l-.01.121a.563.563 0 0 1-.373.486l-.115.04c-.567.2-1.156.349-1.764.441Z"
              />
            </svg>
            <span v-if="showText === 'UParticipantesView'">Participantes</span>
          </router-link>
        </li>

        <li
          v-if="rol === 'user'"
          @mouseover="showText = 'UHorariosView'"
          @mouseleave="showText = ''"
        >
          <router-link to="/uhorarios" aria-label="UHorariosView">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="white"
              class="size-6"
              width="24"
              height="24"
            >
              <path
                fill-rule="evenodd"
                d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 0 0 0-1.5h-3.75V6Z"
                clip-rule="evenodd"
              />
            </svg>
            <span v-if="showText === 'UHorariosView'">Horarios</span>
          </router-link>
        </li>
        <li
          v-if="rol === 'user'"
          @mouseover="showText = 'UReunionesView'"
          @mouseleave="showText = ''"
        >
          <router-link to="/reuniones" aria-label="UReunionesView">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="white"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="white"
              class="size-6"
              width="24"
              height="24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-9A2.25 2.25 0 0 0 2.25 7.5v9a2.25 2.25 0 0 0 2.25 2.25Z"
              />
            </svg>
            <span v-if="showText === 'UReunionesView'">Reuniones</span>
          </router-link>
        </li>

        <li
          v-if="rol === 'user'"
          @mouseover="showText = 'UAgendaView'"
          @mouseleave="showText = ''"
        >
          <router-link to="/agenda" aria-label="UAgendaView">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="white"
              class="size-6"
              width="24"
              height="24"
            >
              <path
                d="M12 11.993a.75.75 0 0 0-.75.75v.006c0 .414.336.75.75.75h.006a.75.75 0 0 0 .75-.75v-.006a.75.75 0 0 0-.75-.75H12ZM12 16.494a.75.75 0 0 0-.75.75v.005c0 .414.335.75.75.75h.005a.75.75 0 0 0 .75-.75v-.005a.75.75 0 0 0-.75-.75H12ZM8.999 17.244a.75.75 0 0 1 .75-.75h.006a.75.75 0 0 1 .75.75v.006a.75.75 0 0 1-.75.75h-.006a.75.75 0 0 1-.75-.75v-.006ZM7.499 16.494a.75.75 0 0 0-.75.75v.005c0 .414.336.75.75.75h.005a.75.75 0 0 0 .75-.75v-.005a.75.75 0 0 0-.75-.75H7.5ZM13.499 14.997a.75.75 0 0 1 .75-.75h.006a.75.75 0 0 1 .75.75v.005a.75.75 0 0 1-.75.75h-.006a.75.75 0 0 1-.75-.75v-.005ZM14.25 16.494a.75.75 0 0 0-.75.75v.006c0 .414.335.75.75.75h.005a.75.75 0 0 0 .75-.75v-.006a.75.75 0 0 0-.75-.75h-.005ZM15.75 14.995a.75.75 0 0 1 .75-.75h.005a.75.75 0 0 1 .75.75v.006a.75.75 0 0 1-.75.75H16.5a.75.75 0 0 1-.75-.75v-.006ZM13.498 12.743a.75.75 0 0 1 .75-.75h2.25a.75.75 0 1 1 0 1.5h-2.25a.75.75 0 0 1-.75-.75ZM6.748 14.993a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Z"
              />
              <path
                fill-rule="evenodd"
                d="M18 2.993a.75.75 0 0 0-1.5 0v1.5h-9V2.994a.75.75 0 1 0-1.5 0v1.497h-.752a3 3 0 0 0-3 3v11.252a3 3 0 0 0 3 3h13.5a3 3 0 0 0 3-3V7.492a3 3 0 0 0-3-3H18V2.993ZM3.748 18.743v-7.5a1.5 1.5 0 0 1 1.5-1.5h13.5a1.5 1.5 0 0 1 1.5 1.5v7.5a1.5 1.5 0 0 1-1.5 1.5h-13.5a1.5 1.5 0 0 1-1.5-1.5Z"
                clip-rule="evenodd"
              />
            </svg>
            <span v-if="showText === 'UAgendaView'">Agenda</span>
          </router-link>
        </li>

        <li
          v-if="rol === 'admin'"
          @mouseover="showText = 'eventosView'"
          @mouseleave="showText = ''"
        >
          <router-link to="/eventos" aria-label="eventosView">
            <i
              class="fas fa-layer-group"
              style="color: white; font-size: 24px"
            ></i>
            <span v-if="showText === 'eventosView'">Eventos</span>
          </router-link>
        </li>
        <li
          v-if="rol === 'admin'"
          @mouseover="showText = 'evaluacionview'"
          @mouseleave="showText = ''"
        >
          <router-link to="/evaluacion" aria-label="evaluacionview">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="white"
              class="size-6"
            >
              <path
                fill-rule="evenodd"
                d="M4.848 2.771A49.144 49.144 0 0 1 12 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97a48.901 48.901 0 0 1-3.476.383.39.39 0 0 0-.297.17l-2.755 4.133a.75.75 0 0 1-1.248 0l-2.755-4.133a.39.39 0 0 0-.297-.17 48.9 48.9 0 0 1-3.476-.384c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97ZM6.75 8.25a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5H12a.75.75 0 0 0 0-1.5H7.5Z"
                clip-rule="evenodd"
              />
            </svg>

            <span v-if="showText === 'evaluacionview'">Evaluaciones</span>
          </router-link>
        </li>
        <li @mouseover="showText = 'logOutView'" @mouseleave="showText = ''">
          <router-link to="/" aria-label="logOutView">
            <i
              class="fa-solid fa-arrow-right-from-bracket"
              style="color: white; font-size: 24px"
            ></i>
            <span v-if="showText === 'logOutView'">Salir</span>
          </router-link>
        </li>
      </ul>

      <div class="menu-toggle" @click="toggleMenu">
        <span v-if="!menuOpen">☰</span>
        <span v-else>✖</span>
      </div>
    </nav>

    <!-- Contenido dinámico de la página -->
    <router-view />
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useAuthStore } from "@/store/auth";

const menuOpen = ref(false);
const showText = ref("");
const rol = ref("");
const authStore = useAuthStore();

const toggleMenu = () => {
  menuOpen.value = !menuOpen.value;
};

onMounted(async () => {
  rol.value = authStore.role;
});
</script>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

/* Estilos del navbar */
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: #1a1a1a;
  color: #f5f5f5;
}

.logo a {
  font-size: 1.5rem;
  color: rgb(0, 0, 0);
  text-decoration: none;
}

.nav-links {
  list-style-type: none;
  display: flex;
  gap: 1rem;
  margin-left: auto;
}

.nav-links li {
  position: relative;
}

.nav-links li a {
  color: #cccccc;
  text-decoration: none;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-links li svg {
  width: 2rem;
  height: 2rem;
}

.nav-links li span {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 1rem;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s;
}

.nav-links li:hover span {
  opacity: 1;
}

.menu-toggle {
  display: none;
  font-size: 2rem;
  cursor: pointer;
}

@media (max-width: 768px) {
  .nav-links {
    display: none;
    flex-direction: column;
    gap: 0.5rem;
  }

  .nav-links.active {
    display: flex;
  }

  .menu-toggle {
    display: block;
  }
}
.logo {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.logo-img {
  height: 40px;
  object-fit: contain;
}

.extra-img {
  height: 80px;
  object-fit: contain;
}
</style>
